import React, { useRef, useState, useEffect } from 'react';
import './ThreeWayToggle.style.scss';

const ThreeWayToggle = ({
  selected,
  onChange,
  name,
  options = [
    { label: 'Option 1', icon: null },
    { label: 'Option 2', icon: null },
    { label: 'Option 3', icon: null }
  ]
}) => {
  const tabsRef = useRef([]);
  const [sliderStyle, setSliderStyle] = useState({ width: 0, left: 0 });

  const handleClick = (option) => {
    const value = typeof option === 'string' ? option : option.label;
    onChange(value);
  };

  // Normalize options to handle both string and object formats
  const normalizedOptions = options.map(opt =>
    typeof opt === 'string' ? { label: opt, icon: null } : opt
  );

  const selectedLabel = typeof selected === 'string' ? selected : selected?.label;
  const selectedIndex = normalizedOptions.findIndex(opt => opt.label === selectedLabel);

  useEffect(() => {
    if (selectedIndex >= 0 && tabsRef.current[selectedIndex]) {
      const activeTab = tabsRef.current[selectedIndex];
      setSliderStyle({
        width: activeTab.offsetWidth,
        left: activeTab.offsetLeft
      });
    }
  }, [selectedIndex]);

  return (
    <div className="three-way-toggle">
      <div className="three-way-toggle-tabs">
        <div
          className="three-way-toggle-slider"
          style={{
            width: `${sliderStyle.width}px`,
            transform: `translateX(${sliderStyle.left}px)`
          }}
        />
        {normalizedOptions.map((option, index) => {
          const isActive = option.label === selectedLabel;
          return (
            <button
              key={option.label}
              ref={el => tabsRef.current[index] = el}
              type="button"
              name={name}
              className={`three-way-toggle-tab ${isActive ? 'active' : ''}`}
              onClick={() => handleClick(option)}
            >
              {option.icon && (
                <span className="three-way-toggle-tab-icon">
                  {<option.icon />}
                </span>
              )}
              <span className="three-way-toggle-tab-label">{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ThreeWayToggle;
